import React, { useState, useEffect, useRef, ReactElement } from 'react';
import { LocationDetailData, Tab } from '../../types';
import { DashboardsTab } from '../../../../../styles/shared-styles';
import LocationDetailAttributesTile from './LocationDetailAttributesTile';
import './LocationDetailTile.scss';

interface LocationDetailTileProps {
    location: LocationDetailData;
}

const LocationDetailTile = ({ location }: LocationDetailTileProps): ReactElement => {

    const detailSubTabs: Array<Tab> = [
        {
            id: 1,
            label: 'Attributes',
            component: <LocationDetailAttributesTile location={location} />
        },
        {
            id: 2,
            label: 'Notes',
            component: <></>
        },
        {
            id: 3,
            label: 'Comments',
            component: <></>
        },
        {
            id: 4,
            label: 'Contacts',
            component: <></>
        },
        {
            id: 5,
            label: 'Files',
            component: <></>
        },
        {
            id: 6,
            label: 'Links',
            component: <></>
        },
    ];

    const [activeTab, setActiveTab] = useState<Tab>(detailSubTabs[0]);

    const onTabClick = async (tab: Tab) => {

        // TODO: Save the selected sub-tab for the user?
        //await saveOverviewTab(tab.id, undefined);

        setActiveTab(tab);
    };

    return (
        <div className='location-detail-tile'>
            <div className='location-detail-tile-header'>
                <div className='location-detail-tile-header-title'>
                    {location.name}
                </div>
                <div className='location-detail-tile-header-actions'>
                    <i className="fa-regular fa-pen"></i>
                    <i className="fa-regular fa-ellipsis"></i>
                </div>
            </div>

            <div className='row g-0 align-items-end'>
                <div className='col-12'>
                    <DashboardsTab className='nav nav-tabs'>
                        {detailSubTabs.map((tab) => (
                            <li key={tab.id} className='nav-item'>
                                <a
                                    className={`nav-link ${activeTab?.id === tab.id ? 'active' : ''}`}
                                    onClick={() => onTabClick(tab)}
                                    type='button'>
                                    <i className={`fa-regular ${tab.icon}`} />
                                    <span>{tab.label}</span>
                                </a>
                            </li>
                        ))}
                    </DashboardsTab>
                </div>

            </div>

            <div className='row w-100'>
                <div className='col-12'>{detailSubTabs.find((tab) => tab.id === activeTab?.id)?.component}</div>
            </div>
        </div>
    );
};

export default LocationDetailTile;
